import { render, staticRenderFns } from "./Terms_and_condition.vue?vue&type=template&id=8326d8e6&"
import script from "./Terms_and_condition.vue?vue&type=script&lang=js&"
export * from "./Terms_and_condition.vue?vue&type=script&lang=js&"
import style0 from "./Terms_and_condition.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports